import CTNButton from '@ctn/ui/components/ctn-button';
import { useEffect, useRef, useState } from 'react';

import { type INotaria } from '@/interfaces/model/TramiteNuevo/INotaria.interface';

import NotaryData from '../components/NotaryData';

type IMapNotariesLocationsProps = {
	readonly foundNotaries: INotaria[];
	readonly setSelectedNotary: (notary: INotaria) => void;
};
type CustomMap = google.maps.Map & {
	codigoNotarioNotaria?: string;
};
type CustomMarker = google.maps.marker.AdvancedMarkerElement & {
	codigoNotarioNotaria?: string;
};

const MapNotariesLocations = ({ foundNotaries, setSelectedNotary }: IMapNotariesLocationsProps) => {
	const ref = useRef<HTMLDivElement>(null);
	const [map, setMap] = useState<CustomMap | undefined>(undefined);
	const [clickedNotary, setClickedNotary] = useState<INotaria | undefined>(undefined);

	const styles = {
		hide: [
			{
				featureType: 'poi',
				stylers: [{ visibility: 'off' }],
			},
			{
				featureType: 'transit',
				stylers: [{ visibility: 'off' }],
			},
		],
	};

	const addMarkerElement = (markerData: INotaria, AdvancedMarkerElement: typeof google.maps.marker.AdvancedMarkerElement, newMap: CustomMap) => {
		const newCustomMarker = new AdvancedMarkerElement({
			position: {
				lat: parseFloat(markerData.notariaCoordenadas.latitud),
				lng: parseFloat(markerData.notariaCoordenadas.longitud),
			},
			map: newMap,
		}) as CustomMarker;

		newCustomMarker.codigoNotarioNotaria = markerData.codigoNotarioNotaria;

		newCustomMarker.addListener('click', () => {
			const matchedNotary = foundNotaries.find((not) => not.codigoNotarioNotaria === newCustomMarker.codigoNotarioNotaria);
			setClickedNotary(matchedNotary);
		});
	};

	useEffect(() => {
		if (foundNotaries.length > 0 && ref.current && !map && window.google?.maps) {
			const initializeMapAndMarkers = async () => {
				const centerLat = parseFloat(foundNotaries[0].notariaCoordenadas.latitud);
				const centerLng = parseFloat(foundNotaries[0].notariaCoordenadas.longitud);

				const newMap: CustomMap = new window.google.maps.Map(ref.current!, {
					center: { lat: centerLat, lng: centerLng },
					zoom: 15,
					streetViewControl: false,
					mapId: 'DEMO_MAP_ID',
				});

				const { AdvancedMarkerElement } = await window.google.maps.importLibrary('marker') as google.maps.MarkerLibrary;

				foundNotaries.forEach((markerData) => {
					addMarkerElement(markerData, AdvancedMarkerElement, newMap);
				});

				newMap.setCenter(new window.google.maps.LatLng(centerLat, centerLng));
				newMap.setOptions({ styles: styles.hide });
				setMap(newMap);
			};

			initializeMapAndMarkers();
		}
	}, [ref, map, foundNotaries]);

	return (
		<div className="[ c-pnp-notary-map ] [ u-mt-24 ]">
			<p className="[ c-pnp-heading-h4 ] ">
				Selecciona un notario para ver los detalles
			</p>
			{clickedNotary && (
				<div className='[ c-pnp-notary-map__content ] [ u-mt-24 ]'>
					<div className="c-pnp-notary-map__notary-data">
						<NotaryData data={clickedNotary} isShowMap={false} />
						<CTNButton
							className="c-pnp-notary-map__btn"
							mode="secondary"
							label="Seleccionar notario"
							size="lg"
							onClick={() => {
								setSelectedNotary(clickedNotary);
							}}
						/>
					</div>
				</div>)}
			<div ref={ref} className="[ c-pnp-notary-map__map ] [ u-mt-24 ]" />
		</div>
	);
};

export default MapNotariesLocations;